import React, { useState } from "react";
import PropTypes from "prop-types";
import { Table } from "antd";
import classes from "./CustomTable.module.css";
import className from "./CustomTableApiKey.module.css";

import { Box, TablePagination } from "@mui/material";

const roundTo2 = (num) =>
  Math.round((Number(num) + Number.EPSILON) * 100) / 100;

const onChange = (pagination, filters, sorter, extra) => {
  console.log("params", pagination, filters, sorter, extra);
};

export const CustomTable = ({ columns, data, customClass = true }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const formattedColumns = columns.map((column) => {
    const isRoundedColumn =
      column.title === "Credit Utilized" ||
      column.title === "Response Time";

    if (isRoundedColumn) {
      return {
        ...column,
        align: "center",
        style: { fontWeight: 500 },
        render: (value) => {
          if (value === null || value === undefined) return "-";
          return roundTo2(value).toFixed(2); 
        },
      };
    }

    return {
      ...column,
      align: "center",
      style: { fontWeight: 500 },
    };
  });

  const tableClass = customClass ? classes["custom-table"] : className["custom-table"];

  const regularData = data?.filter((item) => !item.isTotal) || [];
  const totalRow = data?.filter((item) => item.isTotal) || [];
  const paginatedData = [
    ...regularData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    ...totalRow,
  ];

  return (
    <Box
      sx={{
        borderRadius: "12px",
        border: "1px solid #E1E7EF",
        background: "#FFF",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        padding: "20px",
        
      }}
    >
      <Table
        className={tableClass}
        columns={formattedColumns}
        dataSource={paginatedData}
        onChange={onChange}
        pagination={false}
        scroll={{ x: 1024 }}
      />
      <TablePagination
        component="div"
        count={regularData.length}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(Number(e.target.value));
          setPage(0);
        }}
        rowsPerPageOptions={[15, 25, 50, 100]}
        sx={{
          mt: 2,
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
            fontSize: "12px",
            fontWeight: 600,
          },
          "& .MuiTablePagination-select": {
            fontSize: "12px",
          },
        }}
      />
    </Box>
  );
};

CustomTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  data: PropTypes.arrayOf(PropTypes.object),
  customClass: PropTypes.bool,
};
